import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/dakajilu',
    baseurl2:'/api/swyl/v1',
    //打卡记录列表
    allexec(query){
        return http({
            url: this.baseurl+'/userPunchingCardRecord/selectPage',
            method: 'post',
            params: query
        });
    },
}
